import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import * as Rx from 'rxjs';
import { LoginServiceInterface } from './login.interface';

/**
 * This service can be injected as a login service.
 * It redirects to the gaf/login.php page unless `w=t` is set.
 * In future this may just become a `NoRedirectLogin` service.
 */
@Injectable({
  providedIn: 'root',
})
export class Login implements LoginServiceInterface {
  constructor(private redirectToPhp: RedirectToPhp) {}

  redirect(
    next: string,
    routeSnapshot?: ActivatedRouteSnapshot,
  ): Rx.Observable<boolean> {
    if (routeSnapshot && routeSnapshot.queryParams.w === 't') {
      return Rx.of(true);
    }
    return this.redirectToPhp.doRedirect(`/login?next=${next}`);
  }
}
